import React from 'react';

const SentryTest = (props) => {

	// Using this to test sentry errors in production since no errors were logged for a time

	console.log(doesntExist);

	return (
		<div>

		</div>
	);

};

export default SentryTest;


// WEBPACK FOOTER //
// ./resources/assets/js/pages/SentryTest.js